import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="关于榜单，你可能想先知道这些"
          desc="第一次来 51吃瓜榜 的话，这几个问题能帮你快速明白榜单是怎么运作的。"
          align="center"
        />

        <div className="mx-auto mt-10 max-w-3xl">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={index === 0 ? "" : "border-t border-background-200"}
                >
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
                    >
                      <span className="font-heading text-base font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={
                          isOpen
                            ? "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors"
                            : "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors"
                        }
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}